import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export class KCache <
    DATA_TYPE = unknown,
    GATHER_DATA = unknown,
> {
    // experimental. could be improved.

    afterGather: Array<(err?) => void> = [];
    cached: {[key: string]: DATA_TYPE} = {};
    instigateGather = new Subject();
    thingsToGather: Array<unknown> = [];

    constructor (
        public gatherer: (thingsToGather: Array<unknown>) => Promise<GATHER_DATA>,
        public stuffCache: (cached: {[key: string]: unknown}, getResult: GATHER_DATA) => Promise<void>,
    ) {
        this.instigateGather.pipe(
            debounceTime(1)
        ).subscribe(() => {
            this.doGather().catch(console.error);
        });
    }

    doGather (): Promise<unknown> {
        if (!this.thingsToGather.length) {
            return Promise.resolve();
        }
        return this.gatherer(this.thingsToGather).then((result: GATHER_DATA) => {
            this.thingsToGather = [];
            return this.stuffCache(this.cached, result);
        }).then(() => {
            this.afterGather.forEach((agf) => {
                agf();
            });
            return;
        }).catch((err) => {
            this.afterGather.forEach((agf) => {
                agf(err);
            });
        });
    }

    gatherThing (thing: unknown): void {
        if (this.thingsToGather.indexOf(thing) < 0) {
            this.thingsToGather.push(thing);
        }
    }

    get (key: string): Promise<DATA_TYPE> {
        if (this.cached[key]) {
            return Promise.resolve(this.cached[key]);
        }
        this.gatherThing(key);
        this.instigateGather.next(null);
        return new Promise((resolve, reject) => {
            this.afterGather.push((err?) => {
                if (err) {
                    return reject(err);
                }
                resolve(this.cached[key]);
            });
        });
    }
}
